export function renderHitTemplate(hit, { html, components }) {
  const tgblAlgoliaHitsDataJSON = window.atob(tgblAlgoliaEncodedHitsData);
  const tgblAlgoliaHitsData = jQuery.parseJSON(tgblAlgoliaHitsDataJSON);

  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaHitsData.localized;


  const userCoursesInEachStatus = tgblAlgoliaHitsData['userCourseStatuses']
  let notStarted = Object.values(userCoursesInEachStatus['not_started'])
  let inProgress = Object.values(userCoursesInEachStatus['in_progress'])
  let completed = Object.values(userCoursesInEachStatus['completed'])

  const userCourseProgressPercentages = tgblAlgoliaHitsData['userCourseProgressPercentages']
  const userCourseCertificateLinks = tgblAlgoliaHitsData['userCourseCertificateLinks']
  
  const restUrl = tgblAlgoliaHitsData.restUrl
  const nonce = tgblAlgoliaHitsData.nonce
  const cookie = tgblAlgoliaHitsData.cookie

  return html`
      ${hit.image.large.url !== false
        ? html
          `<div class="tgblAlgolia-card__image"><img src="${hit.image.large.url}" title="${hit.post_title}" /></div>`
        : html `<div class="tgblAlgolia-card__image tgblAlgolia-card__image--placeholder"></div>`
      }
      <div class="tgblAlgolia-card__body">
          ${hit.permalink
            ? html
              `<a href="${hit.permalink}" class="tgblAlgolia-card__title"><h4 class="tgblAlgolia-card__title__text tgblAlgolia-title tgblAlgolia-title--is-level-4">${(hit.title)}</h4></a>`
            : html `<h4 class="tgblAlgolia-card__title__text tgblAlgolia-title tgblAlgolia-title--is-level-4">${(hit.title)}</h4>`
          }
          ${hit.author
            ? html
              `By ${hit.author.name}`
            : html ``
          }
      </div>
      <div class="tgblAlgolia-card__footer">
        <span class="tgblAlgolia-card__button tgblAlgolia-button tgblAlgolia-button--is-width-full tgblAlgolia-button--is-theme-secondary tgblAlgolia-button--is-style-outline">Read more</span>
      </div>
  `;
}